module.exports = __webpack_public_path__ + "media/asset/images/detailPageCoverImage-92752fc558dd660130b12ed292d8c175.png";